import React, { useState } from 'react';
import axios from 'axios';
import { endpoints } from '../servics/apiEndpoints';
import BreadCrumb from '../ass_components/BreadCrumb';
import Meta from '../ass_components/Meta';
import { RiAccountCircleFill } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import RegistrationForm from '../ass_form_components/RegistrationForm';
import DownloadQRCodeSlide from "../ass_components/DownloadQRCodeSlide";
import { useSelector } from 'react-redux';
import {translate} from "../i18n";
import { toast } from "react-toastify";

const SignUp = () => {
    const language_code = useSelector((state) => state.lang)
    const company = useSelector((state) => state.userType).isCompany;

    const representant = {
        "country": "TOGO",
        "firstName": "Daniel-7",
        "lastName": "Tessi",
        "companyEmail": "daniel.cloud.architect@gmail.com",
        "telephone":"52283285875",
        "companyName": "Plateau Ouest",
        "responsabilityInCompany":"Manager",
        "ninea":"767tf65465ughbj",
        "registrationDate":"2024-12-22T14:30:00.000",
        "activatedAt":"2024-12-22T14:30:00.000",
        "modifiedAt":"2024-12-22T14:30:00.000",
        "isHero": false,
        "isCompany": true,
        "isRegular": false,
        "isActivated":true,
        "isEmailVerified":true,
        "isNineaVerified":true,
        "hasAValidContrat":true
    }

    const Roles = {
        "FONDER":"FONDATEUR",
        "ADMINISTRATOR":"ADMINISTRATOR",
        "TECHNOLOGY_MANAGER":"TECHNOLOGY MANAGER",
        "OPERATIONS_MANAGER":"OPERATIONS MANAGER",
        "ACCOUNTING_MANAGER":"ACCOUNTING MANAGER",
        "AGRICULTURE_EXPERT":"AGRICULTURE EXPERT",
        "FIELD_OPERATOR":"FIELD OPERATOR",
        "FIELD_SUPERVISOR":"FIELD SUPERVISOR",
    }

    const Role =
           ["FONDER",
            "ADMINISTRATOR",
            "TECHNOLOGY MANAGER",
            "OPERATIONS MANAGER",
            "ACCOUNTING MANAGER",
            "AGRICULTURE EXPERT",
            "FIELD OPERATOR",
            "FIELD SUPERVISOR"
           ]

    const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
        telephone: '',
        email: ''
    });


    const handleCompanySubmit = async (formData) => {
        // 🔍 DEBUG: Log all formData key-value pairs
        // for (let [key, value] of formData.entries()) {
        //     console.log(`${key}:`, value);
        // }
        try {
            const response = await axios.post(
                endpoints.company,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                }
            );
            console.log(response.data);
            toast.success("Inscription soumise avec succès !");
        } catch (error) {
            console.error(error);
            toast.error("Erreur lors de l'envoi du formulaire");
        }
    };

    const handleNonCompanySubmit = async (formData) => {
        try {
            const response = await axios.post(
                endpoints.nonCompany,
                formData
            );
            console.log(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <>
            <Meta title={'Registration'} />
            <BreadCrumb title='Page de connexion' />
            <div className='wishlist-wrapper assiganto-home-wrapper-2 py-3'>
                <div className='container-xxl'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='d-flex flex-column full-auth-card py-2'>
                                <div className='login-header d-flex'>
                                    <div className='login-picto'>
                                        <img src='images/core_images/assiganto-picto.png' className='img-fluid' alt='small-banner' />
                                    </div>
                                    <div className='login-header-signup'>
                                        <RiAccountCircleFill className='header-options-icons' />
                                        <Link to='/login' className='login-header-singnup-text'>{translate('signin', language_code.lang).label}</Link>
                                    </div>
                                </div>

                                <div className='d-flex login-space py-4'>
                                    <div className='login-form'>
                                        <h5 className='text-start mb-3'>{translate('signup', language_code.lang).label}</h5>

                                        <RegistrationForm
                                            onSubmit={(formData) =>
                                                company ? handleCompanySubmit(formData) : handleNonCompanySubmit(formData)
                                            }
                                        />

                                    </div>

                                    <div className='non_company-pub w-100'>
                                        <div id="carouselDownload" className="carousel slide" data-bs-ride="carousel" data-bs-interval="6000">

                                        <div className="carousel-inner">

                                                {/* Slide 1 : image */}
                                                <div className="carousel-item active">
                                                    <img
                                                        src='images/assiganto-pub-svg/agro.png'
                                                        className='d-block w-100 img-fluid pub-image'
                                                        alt='Promotion'
                                                    />
                                                </div>

                                                {/* Slide 2 : QR code */}
                                                <div className="carousel-item">
                                                    <DownloadQRCodeSlide />
                                                </div>

                                            </div>

                                            {/* Optionnel : contrôles du carousel */}
                                            <div className="d-flex justify-content-between align-items-between">
                                                <button className="carousel-control-prev" type="button" data-bs-target="#carouselDownload" data-bs-slide="prev">
                                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Précédent</span>
                                                </button>
                                                <button className="carousel-control-next" type="button" data-bs-target="#carouselDownload" data-bs-slide="next">
                                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                    <span className="visually-hidden">{translate('button', language_code.lang).next_step_button}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SignUp;
